import { AsyncThunkAction } from 'actions/actions.types'
import { FROM_WINK_ROUTER_STATE_KEY } from 'common/constants'
import { chatPath, contactPath } from 'components/paths'
import { mergeAllUrls } from 'functions/mergeAllUrls'
import { push } from 'functions/router'

export const pushToChatWithWinkAction =
  (userId: number): AsyncThunkAction =>
  async (dispatch) => {
    dispatch(
      push(mergeAllUrls(chatPath, userId, contactPath), true, {
        [FROM_WINK_ROUTER_STATE_KEY]: true,
      })
    )
  }
